var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"r-tip",class:[_vm.type, { center: _vm.center }]},[(_vm.icon)?_c('r-icon',{attrs:{"name":_vm.icon,"color":"var(--text-primary)"}}):_vm._e(),_c('r-text',{attrs:{"weight":600}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }